<template>
<!-- footer -->
<footer>
    <div class="footer_wrap">
        <p>
            <span @click="devGuidePopup">
                &copy; Samsung
            </span>
            <span class="link">
                <a href="javascript:" @click="openPrivacyPopup">{{ $t('FIELD.GLOBAL.ETC.062') }}</a>
            </span>
        </p>
        <div  class="link_site">
            <ul>
                <li>
                    <select id="selectRhqCd" name="selectRhqCd" v-model="selectRhqCd" @change="changeRhqCd($event)" class="slt_footer">
                        <option v-for="item in rhqCdList"
                                :key="item.code"
                                :value="item.code"
                        >{{item.codeName}}</option>
                    </select>
                </li>
                <li>
                    <select id="selectRhqSubCd" name="selectRhqSubCd" @change="changeRhqSubCd($event)" class="slt_footer">
                        <option v-for="(item, index) in rhqSubCdList"
                                :key="item.code"
                                :value="item.code"
                                :selected="selectRhqSubCd ? (item.code == selectRhqSubCd ? true : false) : (index === 0 ? true : false)"
                        >{{item.codeName}}</option>
                    </select>
                    <a href="javascript:" class="btn_white" @click="reLogin">{{ $t('BUTTON.GLOBAL.GO') }}</a>
                </li>
                <li>
                    <picture>
                        <source srcset="/static/images/logo_footer-mo.png" media="(max-width: 767px)"><!-- mobile -->
                        <source srcset="/static/images/logo_footer.png" media="(max-width: 1023px)"><!-- tablet -->
                        <img src="/static/images/logo_footer.png" alt="SAMSUNG SKP"><!-- pc -->
                    </picture>
                </li>
            </ul>
        </div>
    </div>
</footer>
<!-- //footer -->
</template>

<script>
import { mapActions, mapGetters }        from 'vuex';
import _                                 from 'lodash';
import api                               from '@/service';
import store                             from '@/vuex/store';
import { SDLUtil, StringUtil, MenuUtil } from '@/utils';
// Popup components
import PrivacyPolicyPopup                from '~vb/common/PrivacyPolicyPopup';
import DevGuidePopup                     from './DevGuidePopup';

export default {
    name: 'SKPFooter',
    data() {
        return {
            selectRhqCd: '',
            selectRhqNm: '',
            selectRhqSubCd: '',
            selectRhqSubNm: '',

            rhqCdList: [],
            rhqSubCdList: []
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            loginSystem: 'getLoginSystem',
            storeParams: 'getParams',
            userCorpCd: 'getCorpCd',
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq'
        }),
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        getLoginRHQCd() {
            return this.loginRhq || '';
        },
        getLoginCompanyCd() {
            return this.userCorpCd || '';
        },
        getLoginNo() {
            return this.loginNo || '';
        },
    },
    methods: {
        ...mapActions(['changeSubsidiary']),
        openPrivacyPopup(){
            SDLUtil.show(
                PrivacyPolicyPopup,
                {
                    class: 'md_size'
                },
                {
                    width: '780px',
                    height: 'auto',
                    scrollable: true
                },
            );
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.rhqSubCdList = [], this.selectRhqSubCd = '';

            } else {
                this.selectRhqNm = this.getComboBoxName(e.target.id);
                this.getCodeComboList(comboValue, "SUB_AUTH_ACCESS_CD").then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = data.length > 0 ? data[0].code : "";
                });
            }
        },
        // 법인 코드 변경 이벤트
        changeRhqSubCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.selectRhqSubCd = '';
                this.selectRhqSubNm = '';

            } else {
                this.selectRhqSubCd = this.getComboBoxVal(e.target.id);
                this.selectRhqSubNm = this.getComboBoxName(e.target.id);
            }
        },
        // 법인 변경 후 재로그인
        async reLogin() {
            if( this.getLoginCompanyCd !== this.selectRhqSubCd ) {
                const reLoginData = {
                    topRhqCd : this.selectRhqCd,
                    topRhqNm : $('#selectRhqCd :selected').html(),
                    topSubsidiaryCd : this.selectRhqSubCd,
                    topSubsidiaryNm : $('#selectRhqSubCd :selected').html(),
                };

                SDLUtil.showLoadingBar(true);
                const loginResult = await this.changeSubsidiary(reLoginData)
                    .catch(err => {
                        SDLUtil.showLoadingBar(false);
                        SDLUtil.errorAlert(err);
                    });

                this.afterLoginProcess(loginResult);

            } else {
                return SDLUtil.alert('MESSAGE.GROBAL.SELECT.SUBSIDIARY');
            }
        },
        // 법인이 변경된 후 로그인 처리
        afterLoginProcess(loginResult) {
            if (loginResult) this.gotoMain();
            this.$emit('router-reload');
            SDLUtil.showLoadingBar(false);
        },
        // 메인 호출 이벤트
        gotoMain() {
            window.scrollTo(0, 0);
            // Support 로그인인 경우 메인 화면 분기 처리
            if(this.loginSystem == 'SUPPORT') {
                this.$router.push(MenuUtil.getSupportMain());
            } else {
                this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/main` });
            }
        },

        // 개발자 가이드 팝업, Local 에서만 확인 가능
        devGuidePopup() {
            if (SDLUtil.isLocal()) {
                SDLUtil.show(
                    DevGuidePopup,
                    {
                        title: "Development Guide"
                    },
                    {
                        height: 'auto'
                    },
                );
            }
        }
    },
    // keep-alive activated
    activated() {
        this.selectRhqCd    = this.getLoginRHQCd;
        this.selectRhqSubCd = this.getLoginCompanyCd;
    },
    mounted() {
        // 지역/법인 콤보 박스는 DOM 생성 후 이벤트 실행
        this.$nextTick(() => {
            this.getCodeComboList(this.getLoginNo, "RHQ_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqCdList = data;
                });


            this.getCodeComboList(this.getLoginRHQCd, "SUB_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqSubCdList = data;
                });
        });
    },
    // keep-alive deactivated
    deactivated() {
        // 
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/main/SKPFooter.vue